import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import CreateAccount from '@/views/Auth/CreateAccount.vue';
import CreatePassword from '@/views/Auth/CreatePassword.vue';
import ResetPassword from '@/views/Auth/ResetPassword.vue';
import SelectLoan from '@/views/SelectLoan.vue';
import Login from '@/views/Auth/AppLogin.vue';
import InvalidLink from '@/views/InvalidLink.vue';
import Error from '@/views/Error.vue';
import Page404 from '@/views/Page404.vue';
import PaymentSetup from '@/views/PaymentSetup.vue';
import Portal from '@/views/Portal.vue';
import AuthLayout from '@/components/Layout/AuthLayout.vue';
import {
  createAccountGuard,
  routeIfAuthenticated,
  requiresToken,
  authGuard,
} from './guards';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: HomeView,
    redirect: { name: 'home' }
  },
  {
    path: '/auth',
    name: 'auth',
    component: AuthLayout,
    beforeEnter: routeIfAuthenticated,
    children: [
      {
        path: '/login',
        name: 'login',
        component: Login,
      },
      {
        path: '/create-account',
        name: 'create-account',
        component: CreateAccount,
        beforeEnter: createAccountGuard
      },
      {
        path: '/create-password',
        name: 'create-password',
        component: CreatePassword,
      },
    ]
  },
  {
    path: '/select-loan',
    name: 'select-loan',
    component: SelectLoan,
    beforeEnter: authGuard,
  },
  {
    path: '/portal',
    component: Portal,
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        name: 'home',
        component: HomeView,
      },
      {
        path: 'payment-setup',
        name: 'payment-setup',
        component: PaymentSetup,
      },
    ]
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword,
    beforeEnter: requiresToken
  },
  {
    path: '/invalid',
    name: 'invalid',
    component: InvalidLink
  },
  {
    path: '/error',
    name: 'error',
    component: Error
  },
  {
    path: '*',
    name: 'page-404',
    component: Page404
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
